import { PreferredTreeManager } from '@fs/zion-tree-groups'
import { H3, Separator, Skeleton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function PreferredTreeToggler(): JSX.Element {
  const [t] = useTranslation()
  return (
    <div>
      <H3 size="H6">{t('group-management.preferred-tree.label')}</H3>
      <Separator size="nano" />
      <PreferredTreeManager as="toggle" />
    </div>
  )
}

export function PreferredTreeTogglerSkeleton(): JSX.Element {
  return (
    <div>
      <Skeleton.H6 />
      <Separator size="nano" />
      <Skeleton.Toggle />
    </div>
  )
}
